import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import invariant from 'invariant';
import { FormControl } from '@cancercentrum/rcc-bootstrap';
import { useRowModel } from '../hooks/useRowModel';
import ValidationGroupable from './ValidationGroupable';
import { getValidationGroupItems } from './ValidationGroup';
import { useCustomValidationGroupPath } from './ValidationGroupable/useValidationGroupable';
export const Validation = (props)=>{
    const { type = 'error', isValid, className, errorProps, children, isDefaultDirty, validationGroup } = props;
    const validationGroupPath = useCustomValidationGroupPath(validationGroup);
    invariant(validationGroupPath, 'Validation component must be placed inside a ValidationGroup, or have the validationGroup property set');
    const row = useRowModel(validationGroupPath.path);
    const validationGroupItems = getValidationGroupItems(row, validationGroupPath.name);
    const isDirty = isDefaultDirty || validationGroupItems.some((x)=>x.$isDirty);
    const errors = isValid ? [] : [
        {
            message: '',
            isFatal: type === 'error',
            ...errorProps
        }
    ];
    const c = classnames('validation', {
        'is-error': type === 'error',
        'is-warning': type === 'warning'
    }, className);
    return /*#__PURE__*/ _jsx(ValidationGroupable, {
        idPrefix: "Validation_",
        isDirty: isDirty,
        errors: errors,
        className: c,
        children: isDirty && !isValid && /*#__PURE__*/ _jsx(FormControl.Feedback, {
            type: type,
            children: children
        })
    });
};
export default Validation;
